import styled from 'styled-components';
import { Size, Sized, Variable } from '@optimus-web/common';
import { Component, Decision, getComponentVariableToken, MewsLogoVariant } from '@optimus-web/local-tokens';

export const getLogoHeight = ({ size }: { size: Size }) => {
    switch (size) {
        case 'small':
            return 8;
        case 'medium':
            return 16;
        case 'large':
            return 24;
    }
};

const getMewsLogoToken = getComponentVariableToken(Component.MewsLogo, 'variant');

interface MewsLogoWrapperProps extends Required<Sized> {
    protectiveArea?: boolean;
}

export const MewsLogoWrapper = styled.div<MewsLogoWrapperProps>`
    ${(props) => props.protectiveArea && `padding: ${getLogoHeight(props)}px;`}
`;

interface MewsLogoWrapperProps extends Required<Sized>, Variable<MewsLogoVariant> {}

export const MewsLogoSvg = styled.svg<MewsLogoWrapperProps>`
    height: ${getLogoHeight}px;
    width: auto;
    display: block;
`;

export const MewsLogoPath = styled.path`
    fill: ${getMewsLogoToken(Decision.Color)};
`;
